import React, { Component } from "react";
import { connect } from "react-redux";
import _get from "lodash/get";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import homeContent from "../../config/content/homePage";
import { Header, HeaderLabel, PortalLink, PortalDropdown } from "./styles";
import resources from "../../config/content/dashboardPage";
import store from "../../store/store";
import { memberPortalUrl } from "../../config/memberportal.config";
import { adminPortalUrl } from "../../config/admin-portal.config";
// import { LOGOUT } from "../../containers/intermediate/actions";
import headerLogo from "../../assets/tour-images/Logo.png";
import searchIcon from "../../assets/images/search-icon.svg"
import accordianClose from "../../assets/images/accordianClose.png";
import accordianOpen from "../../assets/images/accordianOpen.png";
import MemberPortalIcon from "../../assets/images/member-portal.png";
import AdminPortalIcon from "../../assets/images/admin-portal.png"


const mapStateToProps = state => {
  return {
    toolTipIndex: state.homeReducer.toolTipIndex,
    tourStatus: state.homeReducer.tourStatus
  };
};

/**
 * Header Component
 * @class HeaderComponent
 * @extends {Component}
 * @exports HeaderComponent
 */
class HeaderComponent extends Component {

  state = {
    navExpanded: false,
    height: 270,
    showPortalsDropdown: false,
    selectedPortal: "Member"
  };

  componentDidMount() {
    window.addEventListener("resize", this.manageHeight);
    window.addEventListener("click", this.closePortalDropdown)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.manageHeight);
    window.addEventListener("click", this.closePortalDropdown)
  }

  closePortalDropdown = (e) => {
    if (e.target.className === "open-dropdown") {
      this.setState(prevState => {
        return {
          ...prevState,
          showPortalsDropdown: !prevState.showPortalsDropdown
        }
      })
    } else if (e.target.alt !== "open-dropdown") {
      this.setState({ showPortalsDropdown: false })
    }
  }

  manageHeight = () => {
    const {height} = this.state;
    const windowHeight = window.innerHeight - 50;
    if (height !== windowHeight) {
      this.setState({ height: windowHeight });
    }
  }

  /**
   * Close the hamburger menu
   * @param {string} action action
   * @returns {undefined}
   */
  closeNav(action) {
    this.setState({ navExpanded: false });
    // if (action === LOGOUT)
    //   store.dispatch({
    //     type: LOGOUT
    //   });
  }

  /**
   * Open the hamburger menu
   * @returns {undefined}
   */
  setIsNavExpanded() {
    this.setState({ navExpanded: !this.state.navExpanded });
  }

  /**
   * Funtion to navigate to home page
   * @returns {undefined}
   */
  pathToHome() {
    this.setState({ navExpanded: false });
    this.props.history.push("/home");
  }

  /**
   * Displays current route name in case of mobile
   *
   * @param {string} path location pathname
   * @param {string} links links
   * @returns {string} location pathname
   */
  displayPathName(path, links) {
    const filteredList = links.filter(z => path.indexOf(z.link) >= 0);
    return (filteredList.length > 0 && filteredList[0].label) ? filteredList[0].label : "";
  }

  /**
   * Member portal redirection link click
   * @returns {undefined}
   */
  memberportallink = () => {
    window.open(memberPortalUrl, "__blank");
  }

  portalLinkClicked = (portal) => {
    window.dataLayer = window.dataLayer || [];
    this.setState({ selectedPortal: portal,
      showPortalsDropdown: false });
    if (portal === "Member") {
      window.dataLayer.push({
        event: "PhactMI Custom Event",
        phactmiEventData: {
          "eventAction": "headerPortalLinkClicks",
          "eventLabel": "Member Portal",
          "cd2": "headerPortalLinkClicks",
          "cd3": "Member Portal",
          "cd8": memberPortalUrl
        }
      })
      window.open(memberPortalUrl, "_blank", "noopener,noreferrer");
    } else {
      window.dataLayer.push({
        event: "PhactMI Custom Event",
        phactmiEventData: {
          "eventAction": "headerPortalLinkClicks",
          "eventLabel": "Admin Portal",
          "cd2": "headerPortalLinkClicks",
          "cd3": "Admin Portal",
          "cd8": adminPortalUrl
        }
      })(window.open(adminPortalUrl), "_blank", "noopener,noreferrer");
    }
  }

  onShowPortalsDropdown = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        showPortalsDropdown: !prevState.showPortalsDropdown
      }
    })
  }

  render() {
    const { isUserLoggedIn, authenticationDetails, location, tourStatus, toolTipIndex } = this.props;
    const { headerLinks, phactmi_desc_txt } = homeContent;
    const links = headerLinks;
    const {height, showPortalsDropdown, selectedPortal} = this.state;
    const { pathname } = location;
    return (
      <Header isSearch={pathname.includes("/search")} changeZIndex = {tourStatus ? toolTipIndex === 7 ? true : false : false} maxheight={height}>
        <Container>
          <Navbar expand="xl" collapseOnSelect onToggle={() => this.setIsNavExpanded()} variant="dark" expanded={this.state.navExpanded} >
            {/* <Navbar.Brand as={Link} to='/home' onClick={() => this.closeNav()}>
            </Navbar.Brand> */}
            <div className="phactmi_logo" onClick={() => this.pathToHome()}>
              <img src={headerLogo} alt="phactMI Logo"></img>
              {/* <div className="phactmi_txt" dangerouslySetInnerHTML={{__html: phactmi_desc_txt}}></div> */}
            </div>
            <div>
              <Link className="search-logo" to={"/search"} style={{padding: 0}}><img src={searchIcon} alt="search-products" /></Link>
              <HeaderLabel className="d-xl-none">{this.displayPathName(pathname, links)}</HeaderLabel>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
            </div>
            <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
              <Nav>
                {
                  links.map((item, index) => {
                    if (item.redirect) {
                      return (
                        <Link className={item.customClass}
                          to="/"
                          onClick={() => this.memberportallink()}
                          key={index}
                        >
                          <div className="d-flex justify-content-center">
                            {item.label}
                          </div>
                        </Link>
                      )
                    }
                    else {
                      return (
                        <Link
                          className={(pathname.indexOf(item.link) >= 0)
                            ? item.customClass
                              ? `active-nav ${item.customClass}`
                              : "active-nav"
                            : tourStatus ? item.link === "/members" ? toolTipIndex === 7 ? "member-tour" :
                              item.customClass : item.customClass : item.customClass ? item.customClass : ""
                          }
                          to={item.link} key={index}
                          onClick={() => this.closeNav(item.action)}
                        >
                          <div className="d-flex justify-content-center">
                            {item.label}
                          </div>
                        </Link>
                      )
                    }
                  }
                  )
                }
                <div style={{ position: "relative" }}>
                  <PortalLink>
                    <div className="portal-link"><p onClick={() => this.portalLinkClicked("Member")}><img src={MemberPortalIcon} alt="member-portal-link" /> Member Portal</p></div>
                    <div className="open-dropdown"><img onClick={this.onShowPortalsDropdown} src={showPortalsDropdown ? accordianClose : accordianOpen} alt="open-dropdown"/></div>
                  </PortalLink>
                  {showPortalsDropdown && <PortalDropdown>
                    <li onClick={() => this.portalLinkClicked("Member")}><img src={MemberPortalIcon} alt="member-portal-link" /> Member Portal</li>
                    <li onClick={() => this.portalLinkClicked("Admin")}><img src={AdminPortalIcon} alt="admin-portal-link" /> Admin Portal</li>
                  </PortalDropdown>}
                </div>

              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </Container>
      </Header>
    );
  }
}

export default connect(
  mapStateToProps
)(withRouter(HeaderComponent));